module.exports = __webpack_public_path__ + "img/planning.98e72e0a.jpg";